import axios from 'axios';
import type { LearningXp } from '@/app/track/utils/xpTypes';
import { EMPTY_XP } from '@/app/track/utils/xpTypes';
import { applyCompletionEffects, dispatchXpUpdate } from '@/utils/learningEvents';

export { XP_UPDATED_EVENT, dispatchXpUpdate, applyCompletionEffects } from '@/utils/learningEvents';

export async function fetchLearningXp(token: string): Promise<LearningXp> {
  const response = await axios.post(`${process.env.NEXT_PUBLIC_BASE_URL}/api/learn/xp`, {
    token,
  });
  return (response.data ?? EMPTY_XP) as LearningXp;
}

export async function awardLessonStepXp(
  token: string,
  payload: {
    courseSlug: string;
    lessonId: string | number;
    subLessonId: string | number;
    stepIndex: number;
  }
): Promise<LearningXp | null> {
  try {
    const response = await axios.post(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/learn/award-lesson-step-xp`,
      {
        token,
        courseSlug: payload.courseSlug,
        lessonId: payload.lessonId,
        subLessonId: payload.subLessonId,
        stepIndex: payload.stepIndex,
      }
    );
    const xp = (response.data?.xp ?? null) as LearningXp | null;
    if (xp) {
      dispatchXpUpdate(xp);
    }
    return xp;
  } catch {
    return null;
  }
}

export async function awardQuestionCorrectXp(
  token: string,
  payload: {
    courseSlug: string;
    questionBankId: string | number;
    subLessonId: string | number;
    questionId: string | number;
  }
): Promise<LearningXp | null> {
  try {
    const response = await axios.post(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/learn/award-question-correct-xp`,
      {
        token,
        courseSlug: payload.courseSlug,
        questionBankId: payload.questionBankId,
        subLessonId: payload.subLessonId,
        questionId: payload.questionId,
      }
    );
    const xp = (response.data?.xp ?? null) as LearningXp | null;
    if (xp && (xp.earnedXp ?? 0) > 0) {
      dispatchXpUpdate(xp);
    }
    return xp;
  } catch {
    return null;
  }
}

export async function completeQuestionBank(
  token: string,
  payload: {
    courseSlug: string;
    questionBankId: string | number;
    subLessonId: string | number;
    courseId?: string | null;
  }
): Promise<LearningXp | null> {
  try {
    const response = await axios.post(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/learn/complete-question-bank`,
      {
        token,
        courseSlug: payload.courseSlug,
        questionBankId: payload.questionBankId,
        subLessonId: payload.subLessonId,
        courseId: payload.courseId,
      }
    );
    applyCompletionEffects({
      streak: response.data?.streak,
      xp: response.data?.xp,
    });
    return (response.data?.xp ?? null) as LearningXp | null;
  } catch {
    return null;
  }
}
